module.exports = __webpack_public_path__ + "img/game-feature1.b553327a.png";